/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_TitleInputs */

const en_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing With Natural Rotation`)
};

const es_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguea con rotación natural`)
};

const de_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwingen mit natürlicher Rotation`)
};

const zh_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以自然转动挥杆`)
};

const ar_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سوينغ بدوران طبيعي`)
};

const fr_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguez avec une rotation naturelle`)
};

const vi_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing với xoay tự nhiên`)
};

const sw_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piga Swing kwa Mzunguko wa Asili`)
};

const th_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวิงด้วยการหมุนตัวตามธรรมชาติ`)
};

const bs_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguj s prirodnom rotacijom`)
};

const ja_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自然な回転でスイングする`)
};

const ko_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자연스러운 회전으로 스윙`)
};

const pt_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça o swing com rotação natural`)
};

const it_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai lo swing con la rotazione naturale`)
};

const sv_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svinga med naturlig rotation`)
};

const nl_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing met natuurlijke rotatie`)
};

const da_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sving med naturlig rotation`)
};

const nb_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sving med naturlig rotasjon`)
};

const fi_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svingaa luonnollisella rotaatiolla`)
};

const pl_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguj z naturalną rotacją`)
};

const ru_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свинг с естественным вращением`)
};

const tr_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğal rotasyonla swing yapın`)
};

const hi_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वाभाविक घूर्णन से स्विंग करें`)
};

const id_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengayun dengan Rotasi Alami`)
};

const ms_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayun dengan Putaran Semula Jadi`)
};

const cs_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Švihejte s přirozenou rotací`)
};

const el_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάντε σβινγκ με φυσική περιστροφή`)
};

const he_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בצעו סווינג עם סיבוב טבעי`)
};

const af_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swaai met natuurlike rotasie`)
};

const hu_method_content_step_05_title = /** @type {(inputs: Method_Content_Step_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üss természetes forgással`)
};

/**
* | output |
* | --- |
* | "Swing With Natural Rotation" |
*
* @param {Method_Content_Step_05_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_title = /** @type {((inputs?: Method_Content_Step_05_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_title(inputs)
	if (locale === "de") return de_method_content_step_05_title(inputs)
	if (locale === "zh") return zh_method_content_step_05_title(inputs)
	if (locale === "ar") return ar_method_content_step_05_title(inputs)
	if (locale === "fr") return fr_method_content_step_05_title(inputs)
	if (locale === "vi") return vi_method_content_step_05_title(inputs)
	if (locale === "sw") return sw_method_content_step_05_title(inputs)
	if (locale === "th") return th_method_content_step_05_title(inputs)
	if (locale === "bs") return bs_method_content_step_05_title(inputs)
	if (locale === "ja") return ja_method_content_step_05_title(inputs)
	if (locale === "ko") return ko_method_content_step_05_title(inputs)
	if (locale === "pt") return pt_method_content_step_05_title(inputs)
	if (locale === "it") return it_method_content_step_05_title(inputs)
	if (locale === "sv") return sv_method_content_step_05_title(inputs)
	if (locale === "nl") return nl_method_content_step_05_title(inputs)
	if (locale === "da") return da_method_content_step_05_title(inputs)
	if (locale === "nb") return nb_method_content_step_05_title(inputs)
	if (locale === "fi") return fi_method_content_step_05_title(inputs)
	if (locale === "pl") return pl_method_content_step_05_title(inputs)
	if (locale === "ru") return ru_method_content_step_05_title(inputs)
	if (locale === "tr") return tr_method_content_step_05_title(inputs)
	if (locale === "hi") return hi_method_content_step_05_title(inputs)
	if (locale === "id") return id_method_content_step_05_title(inputs)
	if (locale === "ms") return ms_method_content_step_05_title(inputs)
	if (locale === "cs") return cs_method_content_step_05_title(inputs)
	if (locale === "el") return el_method_content_step_05_title(inputs)
	if (locale === "he") return he_method_content_step_05_title(inputs)
	if (locale === "af") return af_method_content_step_05_title(inputs)
	if (locale === "hu") return hu_method_content_step_05_title(inputs)
	return en_method_content_step_05_title(inputs)
});